import { useTranslation } from 'next-i18next';
import dynamic from 'next/dynamic';
import { useState } from 'react';

const CompanyReviewsDialogs = dynamic(
	() => import('@/components/company/CompanyReviewsDialogs'),
	{ ssr: false }
);
const RatingOverview = dynamic(
	() => import('@/components/company/RatingOverview'),
	{ ssr: false }
);
const RatingBars = dynamic(() => import('@/components/company/RatingBars'), {
	ssr: false,
});

export default function CompanyRating({ company }) {
	const { t } = useTranslation(['common']);
	const [isReviewDialogOpen, setIsReviewDialogOpen] = useState(false);
	return (
		<>
			<section id="rating" className="bg-white">
				<h2 className="text-2xl font-bold tracking-tight text-slate-900">
					{t('common:rating.title', { companyName: company.name })}
				</h2>
				<RatingOverview aggregateRating={company.aggregateRating} />
				<div className="my-4">
					<RatingBars aggregateRating={company.aggregateRating} />
				</div>
				<button
					onClick={() => setIsReviewDialogOpen(true)}
					className="inline-flex w-full items-center justify-center rounded-full border border-gray-300 bg-white px-8 py-2 text-sm font-medium text-gray-900 hover:cursor-pointer hover:bg-gray-50 sm:w-auto lg:w-full"
				>
					{t('common:reviews.recent')}
				</button>
			</section>

			<CompanyReviewsDialogs
				title={t('common:rating.title', { companyName: company.name })}
				company={company}
				isOpen={isReviewDialogOpen}
				onClose={() => setIsReviewDialogOpen(false)}
			/>
		</>
	);
}
